import { updatePresence } from './appsync-client'
import { setUserPresence } from '../stores/presence-store'

/** Min gap between backend ACTIVE publishes (heartbeats also run ~30s). */
const PUBLISH_DEBOUNCE_MS = 45_000

let boundUserId: string | undefined
let lastBackendPublishAt = 0

/** Wire the signed-in user for app-wide activity tracking. */
export function bindActivityPresenceUser(userId: string | undefined): void {
  boundUserId = userId
  if (!userId) lastBackendPublishAt = 0
}

/**
 * Record that the user did something meaningful in the app (tap, navigate, call,
 * message, etc.). Always refreshes the local presence store; publishes ACTIVE to
 * the backend at most once per {@link PUBLISH_DEBOUNCE_MS} unless `force`.
 */
export function recordUserActivity(options?: { force?: boolean }): void {
  if (!boundUserId) return

  const now = Date.now()
  setUserPresence(boundUserId, 'ACTIVE', now)

  const force = options?.force === true
  if (!force && now - lastBackendPublishAt < PUBLISH_DEBOUNCE_MS) return

  lastBackendPublishAt = now
  void updatePresence('ACTIVE').catch(() => {
    /* best effort — sendMessage and other server paths also stamp activity */
  })
}
